import React, { useEffect, useState } from "react";
import "../Admin/ProfilePage.css";
import {
  Modal,
  Box,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Typography,
  Alert,
  Backdrop,
  Fade
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import {
  changePassword,
  getUserGpBlockDistrict,
  updateNumber,
  updateProfile,
} from "../../api/User";
import Swal from "sweetalert2";

const ProfilePage = ({ token, userDetail, userData }) => {
  const name = userData.data?.user_firstname;
  const mobileNumber = userData.data?.user_mobile_no;
  const email = userData.data?.user_email;
  const [village, setVillage] = useState();
  const [role, setRole] = useState(0);
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const [showPasswordOld, setShowPasswordOld] = useState(false);
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordModal, setPasswordModal] = useState(false);
  const [mobileModal, setMobileModal] = useState(false);
  const [userremark, setUserremark] = useState('');
  const [updateMobile, setUpdateMobile] = useState("")
  const [updateMobileRemark, setUpdateMobileRemark] = useState("")

  const [errorMessages, setErrorMessages] = useState({
    oldPassword: "",
    confirmPassword: "",
  });
  const [profileModal, setProfileModal] = useState(false);
  const [GPData, setGPData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [edittedName, setEdittedName] = useState("");
  const [edittedEmail, setEdittedEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [editSuccessMessage, setEditSuccessMessage] = useState("");

  const handleClickShowPasswordOld = () => {
    setShowPasswordOld(!showPasswordOld);
  };
  const handleClickShowPasswordNew = () => {
    setShowPasswordNew(!showPasswordNew);
  };
  const handleClickShowPasswordConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const [errorMessagesMobile, setErrorMessagesMobile] = useState({
    mobileNumber: "",
  });

  const handlePasswordValuesOld = (e) => {
    const pass = e.target.value;
    setOldPassword(pass);
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*\W).{8,}$/;
    return regex.test(password);
  };

  const handlePasswordValuesNew = (event) => {
    const newPassword = event.target.value;
    setNewPassword(newPassword);

    if (newPassword === "") {
      setErrorMessages((prev) => ({
        ...prev,
        newPassword: "",
      }));
    } else if (!validatePassword(newPassword)) {
      setErrorMessages((prev) => ({
        ...prev,
        newPassword: "Password must be at least 8 characters long, include 1 uppercase letter and 1 special character.",
      }));
    } else {
      setErrorMessages((prev) => ({
        ...prev,
        newPassword: "",
      }));
    }
  };

  const handlePasswordValuesConfirm = (e) => {
    const pass = e.target.value;
    if (newPassword === pass) {
      setConfirmPassword(pass);
      setErrorMessages({ ...errorMessages, confirmPassword: "" });
    } else {
      setErrorMessage("");
      setErrorMessages({
        ...errorMessages,
        confirmPassword: "Password Does Not Match",
      });
    }
  };
  const handleMobileValues = async(e) => {
    e.preventDefault();
    const data = {
      new_mobile_no: updateMobile,
      mob_change_remarks: updateMobileRemark,
      user_id : userData.user_id,
      user_name: userData.data.user_firstname,
      user_mob_no: userData.data.user_mobile_no,
      role_id : userData.role_id
    }

    if (updateMobile === mobileNumber) {
      setErrorMessages({
        ...errorMessages,
        mobileNumber: "Please enter a different mobile number",
      });
      return;
    } else {
      await updateNumber(token, data)
      .then((res) => setErrorMessages({
        ...errorMessages,
        mobileNumber: res.message,
      }))
      
    }
    setMobileUpdated(true);
  
    // Close the mobile modal
    setMobileModal(false);
  };

  const [mobileUpdated, setMobileUpdated] = useState(false);
  

  const handlePasswordValues = () => {
    setPasswordModal(false);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrorMessages({ oldPassword: "", confirmPassword: "" });
  };

  const handleProfileValues = () => {
    setProfileModal(false);
  };

  const handlePasswordModal = () => {
    setPasswordModal(true);
  };
  const handleProfileModal = () => {
    setProfileModal(true);
  };

  const handleMobileModal = () => {
    setMobileModal(true);
  };

  const handleSaveChanges = async () => {
    const data = {
      user_id: userDetail?.user_id,
      current_password: oldPassword,
      new_password: confirmPassword,
    };
    if (data.current_password == data.new_password) {
      setErrorMessage("Current Password and New Password cannot be same!!!");
    } else {
      setErrorMessage("");
      try {
        await changePassword(token, data)
          .then((res) => {
            handlePasswordValues();
            setErrorMessage("");
            Swal.fire({
              title: "Password Changed Successfully",
              width: 600,
              padding: "3em",
              color: "#0b8900",
              background: "white",
              backdrop: `
              rgba(211, 211, 211, 0.4)

              no-repeat
            `,
              customClass: {
                confirmButton: "swal2-confirm",
              },
            });
          })
          .catch((error) => {
            if (error.response.data.status == "error") {
              setErrorMessage(error.response.data.error);
            }
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const handleProfileData = async () => {
    const data = {
      id: userDetail?.user_id,
      first_name: edittedName? edittedName: name,
      email: edittedEmail? edittedEmail :email,
    };
    try {
      await updateProfile(token, data)
        .then((res) => {
          setEditSuccessMessage("Changes Successfully");
          handleProfileValues();
          Swal.fire({
            title: "Details Changed Successfully",
            width: 600,
            padding: "3em",
            color: "#0b8900",
            background: "white",
            backdrop: `
            rgba(211, 211, 211, 0.4)

            no-repeat
          `,
            customClass: {
              confirmButton: "swal2-confirm",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEditName = (e) => {
    const name = e.target.value;
    setEdittedName(name);
    console.log(edittedName);
  };
  const handleEditEmail = (e) => {
    const email = e.target.value;
    validate(email);
  };

  const validEmail = new RegExp(
    "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$"
  );
  const validate = (email) => {
    if (!validEmail.test(email)) {
      setEmailErr("Email Id is not Correct");
      console.log(emailErr);
    } else {
      setEdittedEmail(email);
      console.log(edittedEmail);
      setEmailErr("");
    }
  };

  const fetchUserData = async () => {
    const data = {
      id: userDetail?.user_id,
      role_id: userDetail?.role_id,
    };
    try {
      await getUserGpBlockDistrict(token, data)
        .then((res) => {
          setGPData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, [token, userDetail]);

  return (
    <>
    <div class="container mt-3">
  <div class="row">
    <div class="col-sm-4">
    <div className="card border mt-4 mb-4">
        <div className="profile-avatar">
          <img
            className="rounded-circle mt-2"
            width="150px"
            src={process.env.PUBLIC_URL + "/user.png"}
            alt="User Avatar"
          />
          <div className="avatar-info mt-4">
            <span className="avatar-name">{name}</span>
            <span className="avatar-email">{email}</span>
          </div>
        </div>
        <div className="d-flex justify-content-center my-4 mb-4 mt-2">
          <button className="btn mb-2" onClick={handlePasswordModal}>
            Change password
          </button>
        </div>
      </div>
    </div>
    <div class="col-sm-8">
    <div className=" card border mt-4 mb-4 p-4">
        <h4 className="profile-title">Profile</h4>
        <form onSubmit={handleSubmit}>
          <div className="profile-row">
            <div className="profile-column">
              <label className="profile-label">Name</label>
              <input
                type="text"
                className="form-control form-control2"
                value={name}
                disabled
              />
            </div>
            <div className="profile-column col-3">
              <label className="profile-label">View Your GP</label>
              <select
                className="form-select form-control2"
                value={village}
                onChange={(e) => setVillage(e.target.value)}
              >
                <option value="" hidden>
                  Select GP
                </option>
                {GPData &&
                  GPData?.map((GP, index) => (
                    <option key={index} value={GP.VillageId}>
                      {GP.VillageName}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="profile-row">
            <div className="profile-column">
              <label className="profile-label">E-mail</label>
              <input
                type="email"
                className="form-control form-control2"
                value={email}
                disabled
              />
            </div>
            <div className="profile-column">
              <label className="profile-label">Office State</label>
              <input
                type="text"
                className="form-control form-control2"
                value="Haryana"
                disabled
              />
            </div>
            <div className="profile-column">
              <label className="profile-label">Mobile Number</label>
              <input
                type="text"
                className="form-control form-control2"
                value={mobileNumber}
                maxLength="10"
                disabled
              />
            </div>
          </div>
          <div className="profile-row col-12 d-flex justify-content-center">
          <div className="col-6 d-flex justify-content-around align-items-end mt-3">
              <button
                className="btn"
                type="button"
                onClick={handleProfileModal}
              >
                Edit Profile
              </button>
              <button
                className="btn"
                type="button"
                onClick={handleMobileModal}
              >
                Update Number
              </button>
            </div>
          </div>
          
        </form>

        {mobileUpdated && (
          <div className="updated-mobile-section">
          <h4 className="profile-title">Updated Mobile Number</h4>
          <TableContainer component={Paper} className="table-container">
            <Table className="table table-striped table-bordered">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ backgroundColor: "#00bfff" }}>Mobile Number</TableCell>
                  <TableCell align="center" style={{ backgroundColor: "#00bfff" }}>Remark</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="center">{updateMobile}</TableCell>
                  <TableCell align="center">{updateMobileRemark}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        )}
      </div>
    </div>
  </div>
      
      <Modal
        open={passwordModal}
        onClose={handlePasswordValues}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            width: 800,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            mx: "auto",
            my: "15vh",
          }}
        >
          <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
            Change Password
          </Typography>
          <form onSubmit={handleSubmit}>
            <div className="profile-row">
              <div className="profile-column">
                <label className="profile-label">Current Password</label>
                <TextField
                  type={showPasswordOld ? "password" : "text"}
                  className="form-control form-control2"
                  required
                  defaultValue={oldPassword}
                  onBlur={handlePasswordValuesOld}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPasswordOld}
                          edge="end"
                        >
                          {showPasswordOld ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
              </div>
            </div>
            <div className="profile-row">
              <div className="profile-column">
                <label className="profile-label">New Password</label>
                <TextField
                  type={showPasswordNew ? "password" : "text"}
                  className="form-control form-control2"
                  required
                  defaultValue={newPassword}
                  onChange={handlePasswordValuesNew}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPasswordNew}
                          edge="end"
                        >
                          {showPasswordNew ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {errorMessages.newPassword && (
                <Alert severity="error">{errorMessages.newPassword}</Alert>
              )}
              </div>
            </div>
            <div className="profile-row">
              <div className="profile-column">
                <label className="profile-label">Confirm Password</label>
                <TextField
                  type={showPasswordConfirm ? "password" : "text"}
                  className="form-control form-control2"
                  required
                  defaultValue={confirmPassword}
                  onBlur={handlePasswordValuesConfirm}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPasswordConfirm}
                          edge="end"
                        >
                          {showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {errorMessages.confirmPassword && (
                  <Alert severity="error">
                    {errorMessages.confirmPassword}
                  </Alert>
                )}
              </div>
            </div>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <button
                type="submit mx-2"
                className="btn"
                style={{ backgroundColor: "green" }}
                onClick={handleSaveChanges}
              >
                Save changes
              </button>
              <button
                className="btn mx-2"
                style={{ backgroundColor: "red" }}
                onClick={handlePasswordValues}
              >
                Close
              </button>
            </Box>
          </form>
        </Box>
      </Modal>

      <Modal
        open={profileModal}
        onClose={handleProfileValues}
        aria-labelledby="edit-profile-modal-title"
        aria-describedby="edit-profile-modal-description"
        closeAfterTransition
      >
        <Fade in={profileModal}>
        <div>
            <Box
              sx={{
                width: 800,
                bgcolor: "background.paper",
                p: 4,
                borderRadius: 2,
                mx: "auto",
                my: "15vh",
              }}
            >
              <Typography
                variant="h6"
                id="edit-profile-modal-title"
                sx={{ mb: 2 }}
              >
                Edit Profile
              </Typography>
              <form onSubmit={handleSubmit}>
                <div className="profile-row">
                  <div className="profile-column">
                    <label className="profile-label">Name</label>
                    <TextField
                      type="text"
                      className="form-control"
                      defaultValue={name}
                      onChange={handleEditName}
                      required
                    />
                  </div>
                </div>
                <div className="profile-row">
                  <div className="profile-column">
                    <label className="profile-label">E-mail</label>
                    <TextField
                      type="email"
                      className="form-control"
                      defaultValue={email}
                      onChange={handleEditEmail}
                      required
                    />
                    {emailErr && <Alert severity="error">{emailErr}</Alert>}
                  </div>
                </div>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                >
                  <button
                    type="submit"
                    className="btn mx-2"
                    style={{ backgroundColor: "green" }}
                    onClick={handleProfileData}
                  >
                    Save changes
                  </button>
                  <button
                    onClick={handleProfileValues}
                    className="btn mx-2"
                    sx={{ mr: 1 }}
                    style={{ backgroundColor: "red" }}
                  >
                    Close
                  </button>
                </Box>
              </form>
            </Box>
          </div>
        </Fade>
      </Modal>

      <Modal
        open={mobileModal}
        onClose={() => setMobileModal(false)}
        aria-labelledby="edit-mobile-modal-title"
        aria-describedby="edit-mobile-modal-description"
        closeAfterTransition
      >
        <Fade in={mobileModal}>
          <Box
            sx={{
              width: 800,
              bgcolor: "background.paper",
              p: 4,
              borderRadius: 2,
              mx: "auto",
              my: "15vh"
            }}
          >
            <Typography variant="h6" id="edit-mobile-modal-title" sx={{ mb: 2 }}>
              Update Mobile Number
            </Typography>
            <form onSubmit={handleMobileValues}>
            <div className="profile-row">
              <div className="profile-column">
                <label className="profile-label">Mobile Number</label>
                <TextField
                  type="text"
                  className="form-control"
                  defaultValue={mobileNumber}
                  required
                  onChange={(e) => setUpdateMobile(e.target.value)}
                  inputProps={{ maxLength: 10 }}
                  name="mobileNumber"
                />
                {errorMessagesMobile.mobileNumber && (
                  <Alert severity="error">
                    {errorMessagesMobile.mobileNumber}
                  </Alert>
                )}
              </div>
            </div>
            <div className="profile-row">
              <div className="profile-column">
                <label className="profile-label">Remark</label>
                <TextField
                  type="text"
                  className="form-control"
                  defaultValue={updateMobileRemark}
                  onChange={(e)=> setUpdateMobileRemark(e.target.value)}
                  required
                  inputProps={{ maxLength: 10 }}
                  name="remark"
                />
              </div>
            </div>
            <div className="profile-row col-12 d-flex justify-content-center">
              <Button
                className="btn"
                type="submit"
                variant="contained"
              >
                Update Mobile Number
              </Button>
            </div>
          </form>
          </Box>
        </Fade>
      </Modal>
    </div>
    </>
  );
};

export default ProfilePage;
